import React from "react";
import { Routes, Route } from 'react-router-dom';

import CallerDashboard from './../Pages/Caller/Dashboard';
import CallerLeads from './../Pages/Caller/Leads/Lead';
import CallerLeadFilter from './../Pages/Caller/Leads/LeadFilter';
import CallerLeadEdit from './../Pages/Caller/Leads/EditLead';
import CallerLeadProfile from './../Pages/Caller/Leads/LeadProfile';

import CallerLeadAdd from './../Pages/Caller/LeadAdd';

import CallerActivityLogs from './../Pages/Caller/Logs';

import CallerNotifications from './../Pages/Caller/Notification';
import CallerNotificationFilterDataList from './../Pages/Caller/NotificationFilterDataList';
import CallerRemarks from './../Pages/Caller/Remarks';

import Reports from './../Pages/Caller/Reports/Report';

import CallerProfile from './../Pages/Caller/CallerProfile';

const Caller = [
    {
        path: "caller/dashboard", 
        element: <CallerDashboard />,
    },
    {
        path: "caller/leads", 
        element: <CallerLeads />,
    },
    {
        path: "caller/lead/:leadid/edit", 
        element: <CallerLeadEdit />,
    },
    {
        path: "caller/lead/:filtertype", 
        element: <CallerLeadFilter />,
    },
    {
        path: "caller/remarks", 
        element: <CallerRemarks />,
    },
    {
        path: "caller/activity-logs", 
        element: <CallerActivityLogs />,
    },
    {
        path: "caller/notifications", 
        element: <CallerNotifications />,
    },
    {
        path: "caller/notification/:filtertype", 
        element: <CallerNotificationFilterDataList />,
    },
    {
        path: "caller/profile", 
        element: <CallerProfile />,
    },
    {
        path: "caller/lead-profile/:leadid", 
        element: <CallerLeadProfile />,
    },
    {
        path: "caller/lead/add",
        element: <CallerLeadAdd />,
    },
];

export default Caller;